import { isNotNilOrEmpty } from 'utils/ramda'

export const groupFileTypesForTemplateDisplay = (values = [], fileCategories = []) => {
  const safeValues = Array.isArray(values) ? values : []
  const safeCategories = Array.isArray(fileCategories) ? fileCategories : []
  const categoryIds = new Set(safeCategories.map(category => String(category.id)))

  const categories = safeCategories.map(category => ({
    id: category.id,
    label: category.name,
    values: safeValues.filter(type => String(type.fileCategoryId) === String(category.id)) || []
  }))

  const uncategorisedValues = safeValues.filter(type => !categoryIds.has(String(type.fileCategoryId)))

  return isNotNilOrEmpty(uncategorisedValues)
    ? [
        ...categories,
        {
          id: '__uncategorised__',
          label: 'Uncategorised',
          values: uncategorisedValues
        }
      ]
    : categories
}
